import { LogicType_Add, LogicType_And, LogicType_Complex, LogicType_GreaterOrEqual, LogicType_Or, LogicType_StructuredFreeText, } from '../atom-case-operator/index.js';
import { ExpressionOutput_Boolean, ExpressionOutput_Numeric, ExpressionOutput_Range } from '../../_entity/expression/consts.js';
export const AtomsLogicTypes = [LogicType_And,
    LogicType_Or,
    LogicType_Add,
    LogicType_Complex,
    LogicType_StructuredFreeText,
    LogicType_GreaterOrEqual];
export const SingleAtomLogics = [LogicType_Complex, LogicType_StructuredFreeText];
export const BasicAtomsLogicTypes = [LogicType_And];
export const Expression_OutputTypes = [ExpressionOutput_Boolean, ExpressionOutput_Numeric, ExpressionOutput_Range];
//# sourceMappingURL=consts.js.map